<script lang="ts" setup>
import Button from 'primevue/button'

const { t } = useI18n()

const commerceStore = useCommerceStore()
const { selectedPaymentMethod } = storeToRefs(commerceStore)

const paymentMethodsStore = usePaymentMethodsStore()
const { activePaymentMethods: paymentMethods } = storeToRefs(paymentMethodsStore)

function selectPaymentMethod(method: any) {
  selectedPaymentMethod.value = method
}

onMounted(async () => {
  await paymentMethodsStore.fetchItems()
})
</script>

<template>
  <div v-if="paymentMethods && paymentMethods.length > 0">
    <h3 class="my-2 text-base">
      {{ t('Payment Method') }}
    </h3>
    <div class="flex flex-col gap-1 mb-2">
      <Button
        v-for="method in paymentMethods"
        :key="method.id"
        :label="method.name"
        :severity="selectedPaymentMethod?.id === method.id ? 'info' : 'secondary'"
        class="text-sm py-2"
        @click="selectPaymentMethod(method)"
      />
    </div>
  </div>
</template>
